import { type Carer, type Home, HomeSource, UserRole } from '@lmc/ts-common'
import { useRouter } from 'hooks/useRouter'
import { type FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { StepDiscover, StepInvite, StepPin } from './components'
import { StepPreferences } from './components/StepPreferences'

const SetupScreen: FC = () => {
  const [setupStep, setSetupStep] = useState<number>(0)

  const handleNextStep = () => setSetupStep((step) => step + 1)

  const router = useRouter()

  const home: Home | undefined = useSelector(
    (state: { global: { home: Home } }) => state.global.home
  )

  const hasPro = home?.features?.pro?.enabled

  const isSelfServe = home?.source === HomeSource.selfServe

  const isSalesLed = home?.source === HomeSource.salesLed

  const carers = useSelector(
    (state: { data: { carers: Carer[] } }) => state.data.carers
  )

  const user = useSelector(
    (state: { global: { user: Carer } }) => state.global.user
  )

  const hasPreferencesCustomised = home?.preferencesCustomised

  const hasPin = (user as unknown as { hasPin: boolean })?.hasPin

  const hasAdminCarers =
    carers?.filter((carer) => carer.role === UserRole.careHomeAdmin)?.length > 1

  const getSetupStep = () => {
    if (isSelfServe) {
      if (hasPro && hasPreferencesCustomised && hasPin) {
        router.navigate('/')
      }

      if (hasPro && hasPreferencesCustomised && hasAdminCarers) {
        return 3
      }

      if (hasPro && hasPreferencesCustomised) {
        return 2
      }

      if (hasPro) {
        return 1
      }
    }

    if (isSalesLed) {
      if (hasPreferencesCustomised && hasAdminCarers && hasPin) {
        router.navigate('/')
      }

      if (hasPreferencesCustomised && hasAdminCarers) {
        return 3
      }

      if (hasPreferencesCustomised) {
        return 2
      }
    }
    return 0
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setSetupStep(getSetupStep())
  }, [
    hasPro,
    hasPreferencesCustomised,
    hasAdminCarers,
    isSalesLed,
    isSelfServe
  ])

  if (home === undefined || user === undefined || carers === undefined) {
    return null
  }

  const steps = [
    <StepDiscover start={handleNextStep} home={home} />,
    <StepPreferences next={handleNextStep} />,
    <StepInvite next={handleNextStep} />,
    <StepPin homeId={home?.id} />
  ]

  return steps[setupStep]
}
export default SetupScreen
